<template>
  <div>
    <div class="rc-title flex-between">
      <div>收款</div>
      <div class="back" @click="back">X</div>
    </div>
    <div class="content">
      <div class="icon">
        <img src="../../assets/icon/payResult.png" alt />
      </div>
      <div class="text1">收款成功</div>
      <div class="text2">￥{{payResult.cartListTotalPrice}}</div>
      <div class="centerContent">
        <div class="flex-between">
          <div class="text3">原价</div>
          <div
            class="text4"
          >￥{{(Number(payResult.cartListTotalPrice) + Number(payResult.cartListDiscounts)).toFixed(2)}}</div>
        </div>
        <div class="flex-between">
          <div class="text3">优惠</div>
          <div class="text5">￥{{Number(payResult.cartListDiscounts).toFixed(2)}}</div>
        </div>
      </div>
      <div class="text4">请领取小票，期待下次光临</div>
      <!-- <img id="barcode" style="width:100px;height:100px;display:none;" /> -->
      <canvas id="canvas" style="width:100px;height:100px;display:none;"></canvas>

      <div class="buttonGroup">
        <!-- <el-button type="primary" plain>重打标签</el-button> -->
        <el-button type="primary" @click="print" plain>重打小票</el-button>
        <el-button type="primary" @click="back">继续收银</el-button>
      </div>
    </div>
    <!-- <form id="from">
      <div class="center column">
        <div class="center shopName boldFont">{{this.shopInformation.shopName}}</div>
        <img id="barcode" style="width:60%;height:50px" />
      </div>
      <div class="content1">
        <div class="boldFont">流水号：000003</div>
        <div>单号：32913120312903123</div>
        <div>时间：2020-4-20 15:50:02</div>
        <div>收银：白社会</div>
        <div class="br"></div>
      </div>
      <div>
        <div>品名</div>
        <div>
          <div class="flex-between">
            <div style="width:40%">单价</div>
            <div class="center" style="width:30%">数量</div>
            <div style="width:30%;text-align: right;">金额</div>
          </div>
          <div class="flex-between item">
            <div class="column name" style="width:40%">
              <div class>牛肉面</div>
              <div>15.00</div>
            </div>
            <div class="justCenter" style="width:30%">4</div>
            <div style="width:30%;text-align: right;">60.00</div>
          </div>
        </div>
        <div class="br"></div>
      </div>
      <div >
        <div class="flex-between">
          <div>总数：</div>
          <div>4</div>
        </div>
        <div class="flex-between">
          <div>总价：</div>
          <div>4</div>
        </div>
        <div class="flex-between">
          <div>其它优惠：</div>
          <div>4</div>
        </div>
        <div class="flex-between">
          <div>支付方式：</div>
          <div>4</div>
        </div>
        <div class="flex-between">
          <div>应付：</div>
          <div>4</div>
        </div>
        <div class="flex-between boldFont">
          <div class="">实付：</div>
          <div>4</div>
        </div>
        <div class="flex-between boldFont">
          <div  class="">找零：</div>
          <div>4</div>
        </div>
        <div class="br"></div>
      </div>
      <div>
        <div class="flex-between">
          <div>买家：</div>
          <div>匿名用户</div>
        </div>
        <div class="br"></div>
      </div>
      <div>
        <div class>店铺电话：{{this.shopInformation.shopTel}}</div>
        <div class>店铺地址：{{this.shopInformation.shopAddress}}</div>
      </div>
    </form>-->
  </div>
</template>
<script>
import JsBarcode from "jsbarcode";
import QRCode from 'qrcode'
import { Order_payResult } from "../api";
export default {
  data() {
    return {
      payResult: {},
      userList: [],
      shopInformation: [],
      barCode: "",
      orderList: [], //轮询到的信息
      packet: 0.00,
      QueryDetail: "",
      newArr: []
    };
  },
  created() {
    let userList = JSON.parse(this.getCookie("userList"));
    let shopInformation = JSON.parse(this.getCookie("shopInformation"));
    this.userList = userList;
    this.shopInformation = shopInformation;
    this.payResult = JSON.parse(this.$route.query.payResult);
    // console.log(this.$route.query.mallOrderId, 111);
    
    this.onkeydownEnter();
    console.log(this.$route.query.tradeNo, "tradeNo")
    this.$nextTick(()=> {
      this.useqrcode(this.$route.query.tradeNo)
    })
  },
  mounted() {
    this.Order_payResult(this.$route.query.mallOrderId);
  },
  methods: {
    //监听回车键
    onkeydownEnter() {
      document.onkeydown = e => {
        console.log(e);
        if (e.key == "Enter") {
          console.log(1);
          document.onkeydown = "";
          this.back("home");
        }
      };
    },
    Order_payResult(mallOrderId, num) {
      Order_payResult({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        mallOrderId: mallOrderId
      }).then(res => {
        if (!num) {
          num = 0;
          num = num + 1;
        } else {
          num = num + 1;
        }
        console.log("轮询", num);
        if (num >= 10) {
          return;
        }
        if (res.code == 1) {
          this.orderList = res.data;
          this.newArr = JSON.parse(res.data.shopPromotionData)
          console.log(this.newArr, "newArr")
          // JsBarcode("#barcode", '123456789012', {
          //   displayValue: false,
          //   format: "CODE39",
          //   width: 1,
          //   height: 100,
          //   fontOptions: "italic",
          //   font: "fantasy"
          // });
          // JsBarcode("#barcode", res.data.tradeNo)
          // this.barCode = document.getElementById("barcode").src;
          this.print();
        } else {
          setTimeout(() => {
            this.Order_payResult(mallOrderId, num);
          }, 3000);
        }
      });
    },
    useqrcode(qrCodeUrl) {
      this.QueryDetail = qrCodeUrl
      console.log(this.QueryDetail, "this.QueryDetail")
      var canvas = document.getElementById("canvas")
      QRCode.toCanvas(canvas, this.QueryDetail, function (error) {
        if (error) console.error(error)
        // console.log("success");
        var imgUrl = canvas.toDataURL('image/png')
        console.log(imgUrl, "imgUrl");
        localStorage.setItem("imgUrl", imgUrl)
      })
    },
    print() {
      if (this.orderList.length == 0) {
        this.$message.error("等待订单查询完毕");
        return;
      }
      var barCode = localStorage.getItem("imgUrl")
      // var barCode = this.barCode;
      var orderList = this.orderList;
      // JsBarcode("#barcode", orderList.tradeNo, {
      //   displayValue: false
      // });   <canvas id="canvas" style="width: 80%px;height: 50px;"></canvas>
      // this.barCode = document.getElementById("barcode").src;

      console.log(orderList, 'orderList');
      var template_html = `
      <form id="from">
        <div class="center column">
          <div class="center shopName boldFont">${this.shopInformation.shopName}</div>
          <img id="barcode" src="${barCode}" style="width:80%;height:100px" />
        </div>
        <div class="content1">
          <div class="boldFont">流水号：${this.orderList.orderNum}</div>
          <div>单号：${orderList.tradeNo}</div>
          <div>时间：${orderList.payTime}</div>
          <div>收银：${orderList.cashierUserFullName}</div>
          <div class="br"></div>
        </div>
           <div>
        <div>品名</div>
        <div>
          <div class="flex-between">
            <div style="width:40%">单价</div>
            <div class="center" style="width:30%">数量</div>
            <div style="width:30%;text-align: right;">金额</div>
          </div>
      `;
      // var totalNum = 0;
      orderList.products.forEach(item => {
        // totalNum += item.qrcBuyCount;
        template_html += `
          <div class="flex-between item">
            <div class="column name" style="width:40%">
              <div class>${item.goodsName}${item.specDesc ? "(" + item.specDesc + ")" : ""}</div>
              <div>${item.discountPrice ? item.discountPrice : item.retailPrice}</div>
            </div>
            <div class="justCenter" style="width:30%">${item.qrcBuyCount}</div>
              <div style="width:30%;text-align: right;">${item.discountPrice ? item.discountPrice : item.turnoverPrice}</div>
          </div>
       `;
      });
      template_html += `
       </div>
        <div class="br"></div>
      </div>
      <div >
        <div class="flex-between">
          <div>总数：</div>
          <div>${orderList.qrcBuyCount}</div>
        </div>
        <div class="flex-between">
          <div>总价：</div>
          <div>${orderList.totalRetailPrice.toFixed(2)}</div>
        </div>`;
        if (this.newArr.length !== 0) {
          template_html += `
            <div class="flex-between">
              <div class="width35">优惠方式：</div>
              <div class="width65">${this.newArr[0].name}</div>
            </div>
          `
        }
        template_html += `
        <div class="flex-between">
          <div>优惠金额：</div>
          <div>${orderList.totalDiscountPrice.toFixed(2)}</div>
        </div>
        <div class="flex-between">
          <div>支付方式：</div>
          <div>${
            orderList.payInterfacePartyType == 0
              ? "未知"
              : orderList.payInterfacePartyType == 1
              ? "系统"
              : orderList.payInterfacePartyType == 2
              ? "支付宝"
              : orderList.payInterfacePartyType == 3
              ? "微信"
              : orderList.payInterfacePartyType == 11
              ? "线下收款"
              : orderList.payInterfacePartyType == 12
              ? "支付宝记账"
              : orderList.payInterfacePartyType == 13
              ? "微信记账"
              : orderList.payInterfacePartyType == 8
              ? "刷卡记账"
              : orderList.payInterfacePartyType == 10
              ? "会员卡支付"
              : ""
          }</div>
        </div>
        <div class="flex-between">
          <div>应付：</div>
          <div>${orderList.gainMoney.toFixed(2)}</div>
        </div>
        <div class="flex-between boldFont" >
          <div class="">实付：</div>
          <div>${
            orderList.giveChange
              ? (orderList.giveChange + orderList.gainMoney).toFixed(2)
              : orderList.gainMoney.toFixed(2)
          }</div>
        </div>`;
      if (orderList.payInterfacePartyType == 11) {
        template_html += `
         <div class="flex-between boldFont" >
           <div  class="">找零：</div>
           <div>${
            orderList.giveChange.toFixed(2)
           }</div>
         </div>`;
      }
      template_html += `
        <div class="br"></div>
      </div>
      <div>
        <div class="flex-between">
          <div>会员信息：</div>
          <div>${orderList.buyerName ? orderList.buyerName : "匿名用户"}</div>
        </div>
        <div class="br"></div>
      </div>
      <div>
        <div class>店铺电话：${this.shopInformation.shopTel}</div>
        <div class>店铺地址：${this.shopInformation.shopAddress}</div>
      </div>
    </form>
       `;
      template_html += `<style>
     .item {
  margin-top: 10px;
}
#from{
  font-size: 12px;
  padding-right:5px
}
.width35 {
  width: 35%;
}
.width65 {
  width: 65%;
  text-align: right;
  right: 0;
  font-size: 10px;
}
.br{  
  border-bottom: 1px dashed  #000;
  margin: 10px 0;
}
.boldFont{
   font-size: 22px;
  font-weight: 600;
}
.shopName{
  margin-bottom:20px;
 
}
.center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.row {
  display: flex;
  flex-direction: row;
}

.column {
  display: flex;
  flex-direction: column;
}

.justCenter {
  display: flex;
  justify-content: center;
}

.alignCenter {
  display: flex;
  align-items: center;
}
.flex-between {
  display: flex;
  justify-content: space-between;
}</style>
`;

      LODOP.PRINT_INIT("订单小票");
      LODOP.ADD_PRINT_HTM(0, 0, "100%", "100%", template_html);
      LODOP.SET_PRINT_PAGESIZE(3, 600, 40, "");
      // LODOP.PREVIEW(); //预览
      LODOP.PRINT(); //打印
    },
    back(a) {
      this.$emit("back")
      if (a) {
        this.$router.push("/cashierOrder/cashierOrderHome");
        return;
      }
      this.$router.go(-1);
    }
  }
};
</script>

<style>
     .item {
  margin-top: 10px;
}
#from{
  font-size: 12px;
  padding-right:5px
}
.width35 {
  width: 35%;
}
.width65 {
  width: 65%;
  text-align: right;
  right: 0;
  font-size: 10px;
}
.br{  
  border-bottom: 1px dashed  #000;
  margin: 10px 0;
}
.boldFont{
   font-size: 22px;
  font-weight: 600;
}
.shopName{
  margin-bottom:20px;
 
}
.center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.row {
  display: flex;
  flex-direction: row;
}

.column {
  display: flex;
  flex-direction: column;
}

.justCenter {
  display: flex;
  justify-content: center;
}

.alignCenter {
  display: flex;
  align-items: center;
}
.flex-between {
  display: flex;
  justify-content: space-between;
}</style>
`;

      LODOP.PRINT_INIT("订单小票");
      LODOP.ADD_PRINT_HTM(0, 0, "100%", "100%", template_html);
      LODOP.SET_PRINT_PAGESIZE(3, 600, 40, "");
      // LODOP.PREVIEW(); //预览
      LODOP.PRINT(); //打印
    },
    back(a) {
      this.$emit("back")
      if (a) {
        this.$router.push("/cashierOrder/cashierOrderHome");
        return;
      }
      this.$router.go(-1);
    }
  }
};
</script>
<style  scoped>
#canvas{
  width: 15%!important;
  height: auto!important;
}
.item {
  margin-top: 10px;
}
#from {
  font-size: 12px;
  width: 600px;
  padding: 30px 20px;
}
.br {
  /* height: 1px; */
  border-bottom: 1px dashed #000;
  margin: 10px 0;
}
.boldFont {
  font-size: 22px;
  font-weight: 600;
}
.shopName {
  margin-bottom: 20px;
}
.center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.row {
  display: flex;
  flex-direction: row;
}

.column {
  display: flex;
  flex-direction: column;
}

.justCenter {
  display: flex;
  justify-content: center;
}

.alignCenter {
  display: flex;
  align-items: center;
}
.flex-between {
  display: flex;
  justify-content: space-between;
}

/* print */
.content div {
  margin-top: 20px;
}
.text5 {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(251, 39, 39, 1);
  margin: 0 !important;
}
.text4 {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  /* margin-bottom: 19px; */
  margin: 0 !important;
}
.text3 {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  margin: 0 !important;
}
.text2 {
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  /* margin-bottom: 40px; */
}
.text1 {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  /* margin-bottom: 25px; */
}
.centerContent {
  width: 60%;
  padding: 27px 10px;
  padding-top: 0;
  border-bottom: 1px solid #dcdcdc;
  border-top: 1px solid #dcdcdc;
  /* margin-bottom: 48px; */
}
.content {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 100px;
  flex-direction: column;
}

.back {
  color: gray;
  font-size: 20px;
  cursor: pointer;
}
.rc-title {
  /* background: #eeeeee; */
  border-bottom: 1px solid #eee;
  box-sizing: border-box;
  padding: 18px;
  height: 60px;
  font-size: 16px;
}
@media screen and (max-height: 840px) {
  .content div {
    margin-top: 10px !important;
  }
  .content {
    padding-top: 50px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/page/cashierOrderPayResult.vue